export default __webpack_public_path__ + "static/media/logo.0cc3138e.svg";